import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DailyTask = ({ userDetails }) => {
  const [clicks, setClicks] = useState(0);             // Local clicks before save
  const [serverClicks, setServerClicks] = useState(0); // Total clicks from server
  const [showFlash, setShowFlash] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  // Helper to get user email safely
  const userEmail = userDetails?.email || '';

  // Fetch total clicks from server on component mount or userEmail change
  useEffect(() => {
    if (!userEmail) return;

    const fetchTotalClicks = async () => {
      try {
        const response = await axios.get('https://www.sharedvision-partners.online/v1/API/clicks_api.php', { params: { email: userEmail } });
        setServerClicks(response.data.totalClicks);
      } catch (error) {
        console.error('Failed to fetch total Coins:', error);
        setMessage('Failed to load total Coins from server.');
      }
    };

    fetchTotalClicks();
  }, [userEmail]);

  const handleClick = () => {
    setClicks((prev) => prev + 0.25);
    setShowFlash(true);
    setAnimating(true);

    setTimeout(() => setShowFlash(false), 800);
    setTimeout(() => setAnimating(false), 200);
  };

  const handleSave = async () => {
    if (!userEmail) {
      setMessage('User email not found. Cannot save clicks.');
      return;
    }

    if (clicks === 0) {
      setMessage('No Coin to save.');
      return;
    }

    setIsSaving(true);
    setMessage('');

    try {
      // Save clicks to server
      const response = await axios.post('https://www.sharedvision-partners.online/v1/API/clicks_api.php', { email: userEmail, clicks });

      // Update serverClicks with response from server (new total)
      setServerClicks(response.data.totalClicks);

      setMessage('Coins saved and Balance updated!');
      setClicks(0); // Reset local clicks after saving
    } catch (error) {
      console.error(error);
      setMessage('Error saving Coins, please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: '700px',
        margin: '40px auto',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: '#333',
      }}
    >
      <h2 style={{ textAlign: 'center', marginBottom: '10px' }}>
        Welcome to your Daily Task Room, I'm happy to see you today
      </h2>
      <p style={{ textAlign: 'center', marginBottom: '30px', color: '#555' }}>
       Couple of task for you to do today, Join the Coin Farming, just tap the button below to earn coins.
        <br />
      </p>
      
      <section
        style={{
          background:
            'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
          borderRadius: '12px',
          padding: '30px 40px',
          boxShadow: '0 10px 25px rgba(37, 117, 252, 0.3)',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <h3
          style={{
            marginBottom: '20px',
            fontWeight: '700',
            fontSize: '1.8rem',
          }}
        >
          Tap Tap Task (Free Coins)
        </h3>
        <button
          onClick={handleClick}
          style={{
            padding: '14px 30px',
            fontSize: '18px',
            fontWeight: '600',
            cursor: 'pointer',
            borderRadius: '50px',
            border: 'none',
            backgroundColor: '#fff',
            color: '#2575fc',
            boxShadow: '0 6px 15px rgba(37, 117, 252, 0.4)',
            position: 'relative',
            transform: animating ? 'scale(0.95)' : 'scale(1)',
            transition: 'transform 0.15s ease',
            userSelect: 'none',
          }}
        >
          Tap to earn coins
          {/* Flashing +0.25 */}
          {showFlash && (
            <span
              style={{
                position: 'absolute',
                top: '-30px',
                right: '20px',
                color: '#ffd700',
                fontWeight: 'bold',
                fontSize: '1.2rem',
                animation: 'flashUp 0.8s forwards',
                userSelect: 'none',
                textShadow: '0 0 6px #ffd700',
              }}
            >
              +0.25
            </span>
          )}
        </button>

        <div
          style={{
            marginTop: '30px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '15px',
            padding: '25px 0',
            fontSize: '2.2rem',
            fontWeight: '700',
            letterSpacing: '1px',
            userSelect: 'none',
            boxShadow: 'inset 0 0 15px rgba(255, 255, 255, 0.4)',
          }}
        >
          {clicks.toFixed(2)}
        </div>

        <button
          onClick={handleSave}
          disabled={isSaving || clicks === 0}
          style={{
            marginTop: '20px',
            padding: '12px 28px',
            fontSize: '16px',
            fontWeight: '700',
            borderRadius: '50px',
            border: 'none',
            backgroundColor: isSaving ? '#999' : '#ffd700',
            color: isSaving ? '#666' : '#333',
            cursor: isSaving || clicks === 0 ? 'not-allowed' : 'pointer',
            boxShadow: '0 5px 15px rgba(255, 215, 0, 0.6)',
            userSelect: 'none',
          }}
        >
          {isSaving ? 'Saving...' : 'Secure Coins'}
        </button>

        {message && (
          <p
            style={{
              marginTop: '15px',
              fontWeight: '600',
              color: '#ffd700',
              textShadow: '0 0 6px #ffd700',
              userSelect: 'none',
            }}
          >
            {message}
          </p>
        )}

        <div
          style={{
            marginTop: '40px',
            padding: '20px',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 8px 20px rgba(37, 117, 252, 0.3)',
            color: '#2575fc',
            fontSize: '1.8rem',
            fontWeight: '700',
            userSelect: 'none',
          }}
        >
          Total Clicks: {serverClicks.toFixed(2)}
        </div>
      </section>

      {/* Flash animation keyframes */}
      <style>
        {`
          @keyframes flashUp {
            0% {
              opacity: 1;
              transform: translateY(0);
            }
            100% {
              opacity: 0;
              transform: translateY(-30px);
            }
          }
        `}
      </style>
    </div>
  );
};

export default DailyTask;
